import axios from '@axios'

export const state = {
  invoices: [],
}

export const getters = {
  allInvoices: (state) => state.invoices,
}

export const mutations = {
  GET_INVOICES: (state, resp) => {
    if (!resp) return null
    state.invoices = resp
  },
  CREATE_INVOICE: (state, resp) => {
    if (!resp) return null
    state.invoices = [...state.invoices, resp]
  },
  DELETE_INVOICE: (state, resp) => {
    if (!resp) return null
    state.invoices = state.invoices.filter((invoice) => invoice.id !== resp.id)
  },
}

export const actions = {
  async createInvoice({ commit, dispatch }, form) {
    return axios.post('/api/cars/invoice', form)
  },
  async getUnavailableFees({ commit, dispatch }, carId) {
    return axios.get(`/api/cars/${carId}/unavailable-fees`)
  },
}
